/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inclusive_Every_Loris_BelieveInputs */

const fr_inclusive_every_loris_believe = /** @type {(inputs: Inclusive_Every_Loris_BelieveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valider`)
};

/**

* @param {Inclusive_Every_Loris_BelieveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const inclusive_every_loris_believe = /** @type {((inputs?: Inclusive_Every_Loris_BelieveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inclusive_Every_Loris_BelieveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_inclusive_every_loris_believe(inputs)
});